import { autoserialize, autoserializeAs } from 'cerialize';

export class User {
  @autoserialize id!: string;
  @autoserialize name!: string;
  @autoserialize email!: string;
  @autoserialize roles!: string[];
  @autoserializeAs('preferred_username') username!: string;
  @autoserializeAs('language_code') languageCode!: string;
}
